<ng-container #container></ng-container>

